import React from 'react';
import PropTypes from 'prop-types';
import { SubmissionButton } from '../../Button';
import { darken } from 'polished';
import withStyledButtonText from '../hoc/withStyledButtonText';

function SubmitButton({ text, ctaButtonStyle, ...restProps }) {
  const originalBackgroundColor = ctaButtonStyle?.backgroundColor || '';
  const [backgroundColor, setBackgroundColor] = React.useState(originalBackgroundColor);
  const cssStyle = ctaButtonStyle || {};

  const handleMouseOver = () => {
    if (originalBackgroundColor) {
      setBackgroundColor(darken('0.1', originalBackgroundColor));
    }
  };

  const handleMouseOut = () => {
    if (originalBackgroundColor) {
      setBackgroundColor(originalBackgroundColor);
    }
  };

  return (
    <SubmissionButton
      type="submit"
      noMargin
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      {...restProps}
      styles={cssStyle}
      style={{ backgroundColor }}
      data-css-selector="cta button"
    >
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </SubmissionButton>
  );
}

SubmitButton.propTypes = {
  text: PropTypes.string,
};

export default withStyledButtonText(SubmitButton);
